export const SEAT_FILTER_SHORT_NAME = "seatRange"
export const seatDefault = [0, 50]

const sN = SEAT_FILTER_SHORT_NAME
const sD = seatDefault

export const SEAT_FILTER_CONFIG = {
  short_name: sN,
  default_values: sD,
  is_default: value => testSeatDefault(value), //right before clean up
  format_to_api: value => formatSeatForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatSeatFromURL(value) //
}

export const formatSeatFromURL = value => {
  let cleanValue = null
  if (value) {
    if (value instanceof Array) {
      if (value.length === 2) {
        //cast them to numbers
        let minSeat = Number(value[0])
        let maxSeat = Number(value[1])
        if (!isNaN(minSeat) && !isNaN(maxSeat)) {
          if (minSeat < maxSeat) {
            //At somepoint we should round these to match the slider?
            //eh, doesn't matter. we'll do this later. only a problem if some one
            //manually messes this up.
            cleanValue = []
            cleanValue[0] = minSeat
            cleanValue[1] = maxSeat
          }
        }
      }
    }
  }

  return cleanValue
}

export const buildSeatLabel = (currentSeats) => {
  let seatLabel = ""

  if (
    currentSeats[0] === seatDefault[0] &&
    currentSeats[1] !== seatDefault[1]
  ) {
    seatLabel = seatDefault[0] + "in - " + currentSeats[1] + "in"
  }

  if (
    currentSeats[0] !== seatDefault[0] &&
    currentSeats[1] === seatDefault[1]
  ) {
    seatLabel = currentSeats[0] + "in - " + seatDefault[1] + "in"
  }

  if (
    currentSeats[0] !== seatDefault[0] &&
    currentSeats[1] !== seatDefault[1]
  ) {
    seatLabel = currentSeats[0] + "in - " + currentSeats[1] + "in"
  }

  if (
    currentSeats[0] === seatDefault[0] &&
    currentSeats[1] === seatDefault[1]
  ) {
    seatLabel = "All Seats"
  }

  return seatLabel
}

export const isSeatRangeDefault = value => {
  if (value[0] === seatDefault[0] && value[1] === seatDefault[1]) {
    return true
  } else {
    return false
  }
}
//////FOR API SETTING UP
export const formatSeatForAPI = value => {
  if (value) {
    return {
      min_seat: value[0],
      max_seat: value[1]
    }
  } else {
    return {}
  }
}

export const testSeatDefault = value => {
  return isSeatRangeDefault(value)
}
